"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLeaflet = require("react-leaflet");
require("leaflet/dist/leaflet.css");
require("leaflet-geosearch/dist/geosearch.css");
var _Position = require("../../constants/Position");
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsMap component renders a map using react-leaflet with customizable markers.
 *
 * @component
 *
 * @param {number} latitude - The latitude of the center of the map.
 * @param {number} longitude - The longitude of the center of the map.
 * @param {number} zoom - The initial zoom level of the map.
 * @param {Array} markers - An array of MarkerComponent objects representing markers on the map.
 * @param {boolean} redirectToGoogleMap - A flag indicating whether to redirect to Google Maps on marker click.
 *
 * @returns {JSX.Element} - The rendered DmsMap component.
 * 
 * to use filter:
 * filter = {
 *      options: [],//a list that contains all the filters
 *      handleOptionClick: funct () => {} // a function that is called when a filter is chose
 * }
 */
const DmsMap = _ref => {
  let {
    latitude,
    longitude,
    zoom,
    markers,
    redirectToGoogleMap,
    filter = {},
    height = "100vh",
    width = "100vw"
  } = _ref;
  const [selectedOptions, setSelectedOptions] = (0, _react.useState)([]);
  const [mouseOnOption, setMouseOnOption] = (0, _react.useState)([]);

  /**
   * Handles marker click event. If redirectToGoogleMap is true, opens Google Maps with the marker's coordinates.
   *
   * @param {number} lat - The latitude of the clicked marker.
   * @param {number} lng - The longitude of the clicked marker.
   */
  const handleMarkerClick = (lat, lng) => {
    if (redirectToGoogleMap) {
      const url = "https://www.google.com/maps/search/?api=1&query=".concat(lat, ",").concat(lng);
      window.open(url, '_blank');
    }
  };

  /**
   * MarkerComponent renders a marker on the map with optional popup and tooltip.
   *
   * @component
   *
   * @param {number} latitude - The latitude of the marker.
   * @param {number} longitude - The longitude of the marker.
   * @param {JSX.Element} popup - The content of the popup associated with the marker.
   * @param {string} tooltip - The content of the tooltip associated with the marker.
   *
   * @returns {JSX.Element} - The rendered Marker component.
   */
  const MarkerComponent = _ref2 => {
    let {
      latitude,
      longitude,
      popup = null,
      tooltip = null
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_reactLeaflet.Marker, {
      position: [latitude, longitude],
      icon: _Position.blueMarkerIcon,
      eventHandlers: {
        click: () => handleMarkerClick(latitude, longitude)
      }
    }, popup && /*#__PURE__*/_react.default.createElement(_reactLeaflet.Popup, null, popup), tooltip && /*#__PURE__*/_react.default.createElement(_reactLeaflet.Tooltip, {
      direction: "top",
      offset: [0, -20],
      opacity: 1
    }, tooltip));
  };
  const handleOptionClick = option => {
    setSelectedOptions(prevSelectedOptions => {
      if (prevSelectedOptions.includes(option)) {
        return prevSelectedOptions.filter(item => item !== option);
      } else {
        return [...prevSelectedOptions, option];
      }
    });
  };
  const FilterOptions = () => {
    if (Object.keys(filter).length > 0) {
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
        bordered: true,
        style: {
          position: 'fixed',
          bottom: '20px',
          left: '5%',
          backgroundColor: 'transparent',
          zIndex: 1000,
          width: '20%'
        }
      }, /*#__PURE__*/_react.default.createElement("tbody", null, filter.options.map((option, index) => /*#__PURE__*/_react.default.createElement("tr", {
        key: index,
        style: {
          cursor: 'pointer'
        }
      }, /*#__PURE__*/_react.default.createElement("td", {
        style: {
          backgroundColor: mouseOnOption === option.name ? 'lightgray' : selectedOptions.includes(option.name) ? 'lightgray' : '#3c8dbc',
          color: 'white'
        },
        onClick: () => {
          filter.handleOptionClick(option.name);
          handleOptionClick(option.name);
        },
        onMouseEnter: () => setMouseOnOption(option.name),
        onMouseLeave: () => setMouseOnOption(null)
      }, option.name)))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'sticky'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.MapContainer, {
    center: [latitude !== null && latitude !== void 0 ? latitude : _Position.defaultPosition.lat, longitude !== null && longitude !== void 0 ? longitude : _Position.defaultPosition.lng],
    zoom: zoom !== null && zoom !== void 0 ? zoom : _Position.defaultPosition.zoom,
    style: {
      height: height,
      width: width
    },
    scrollWheelZoom: false
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.TileLayer, {
    url: _Position.tileLayer.url,
    attribution: _Position.tileLayer.attribution,
    maxZoom: _Position.tileLayer.maxZoom,
    accessToken: _Position.tileLayer.accessToken
  }), markers.map((marker, index) => /*#__PURE__*/_react.default.createElement(MarkerComponent, {
    key: index,
    latitude: marker.latitude,
    longitude: marker.longitude,
    popup: marker.popup,
    tooltip: marker.tooltip
  }))), /*#__PURE__*/_react.default.createElement(FilterOptions, null));
};
exports.DmsMap = DmsMap;
DmsMap.propTypes = {
  latitude: _propTypes.default.number,
  longitude: _propTypes.default.number,
  zoom: _propTypes.default.number,
  markers: _propTypes.default.array,
  redirectToGoogleMap: _propTypes.default.bool
};
DmsMap.defaultProps = {
  markers: [],
  redirectToGoogleMap: false
};